import { identityClient, Identity } from '@wajeez-web/core/api-base';

const preferances = new Identity.Identity_TablePreferences_Client(
  undefined,
  identityClient
);

export async function addTablePreferances(
  data: Identity.TablePreferenceInputOfInteger
) {
  preferances.tablePreferences_post_V1(data);
}
export async function getTablePreferancesByNane(tableName: string) {
  const response = await preferances.byTableName_V1GET(tableName);

  return response.data;
}
